import { render, staticRenderFns } from "./affidavitValidationModal.vue?vue&type=template&id=3d17ed69&scoped=true&"
import script from "./affidavitValidationModal.vue?vue&type=script&lang=js&"
export * from "./affidavitValidationModal.vue?vue&type=script&lang=js&"
import style0 from "./affidavitValidationModal.vue?vue&type=style&index=0&id=3d17ed69&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d17ed69",
  null
  
)

export default component.exports